import HospitalTable from './HospitalTable';

export default HospitalTable;
